import gql from "graphql-tag";

export const saveConversationInCaseManagement = gql`
  mutation saveCasesInConversation($auth: AuthInput, $conversationId: String!, $folders: [String]!) {
    saveCasesInConversation(input: $auth, conversationId: $conversationId, selectedFolders: $folders) {
      id
      text
      status
    }
  }
`;

// queryName:saveFoldersInConversation, params: conversationId, conversationFolders
export const saveFoldersInConversation = gql`
  mutation saveFoldersInConversation($auth: AuthInput, $conversationId: String!, $folders: [String]!) {
    saveFoldersInConversation(input: $auth, conversationId: $conversationId, selectedFolders: $folders) {
      id
      text
      status
    }
  }
`;

export const bulkFoldersMutation = gql`
  mutation bulkFoldersMutation($auth: AuthInput, $conversationId: [String], $selectedFolders: [String], $action: String) {
    bulkCoversationSafe(input: $auth, conversationId: $conversationId, selectedFolders: $selectedFolders, action: $action) {
      status
    }
  }
`;

export const bulkCaseMutation = gql`
  mutation bulkCaseManagementMutation($auth: AuthInput, $conversationId: [String], $selectedFolders: [String], $action: String, $riskRating: String) {
    bulkCaseManagementMutation(
      input: $auth
      conversationId: $conversationId
      selectedFolders: $selectedFolders
      action: $action
      riskRating: $riskRating
    ) {
      status
    }
  }
`;

export const getConversationCases = gql`
  query getConversationCases($conversationId: String) {
    getConversationCases(conversationId: $conversationId) {
      convIncident {
        caseId
        caseName
        status
        riskRating
        incidentThreadId
        forwardTo
      }
      caseDetails {
        caseStatus
        contentStatus
        legalHold
        observers
        reviewers
        reviewersName
        caseThreadId
      }
    }
  }
`;

export const getFilterRecordings = gql`
  query getFilterRecordings($val: String!, $filter: RecordingFilterInputType, $withSave: Boolean, $auth: AuthInput, $path: String) {
    getFilterRecordings(search: $val, filter: $filter, withSave: $withSave, input: $auth, path: $path) {
      userRules {
        defaultFilter {
          id
          type
          cycle
          startDate
          endDate
          categories
          policies
          persons
        }
        recordingFilter {
          id
          type
          cycle
          startDate
          endDate
          persons
          defaultFilter
          userFilter
          categories
          integrations
          policies
          folders
          incidentStatus
        }
      }
      statistics {
        count
      }
      days {
        date
        content {
          day
          timein
          timeout
          topic
          id
          conversationId
          policies {
            policyId
            monitoredBy
            riskRating
          }
          recordingType
          duration
          thumbnail
          speech2Text
          notes
          isVideo
          hasVideo
          hasAudio
          hasChat
          isHistoryVault
          hasFiles
          hasScreenSharing
          replayAllowed
          archiveAllowed
          archiveAccessType
          isRestoreApproved
          isApprover
          linkedUser {
            id
            userId
            tenantId
            name
          }
          callStartMs
          ownerDisplayName
          userId
          archiveStatus
          hasRestoreStarted
          customFields
          conversationSafe
          conversationSafeFolders {
            id
            name
          }
          ttl
        }
      }
    }
  }
`;

export const getAllFolders = gql`
  query ent($auth: AuthInput, $filter: String) {
    getConversationSafeFolders(input: $auth, filter: $filter) {
      id
      name
      tenantId
      description
      visibilityDetails {
        visibilityDetailsActive
        visibilityDetailsNotes
        visibilityDetailsTranscript
        visibilityDetailsTTL
        visibilityDetailsAnalytics
        visibilityDetailsAnalyticsChange
        visibilityDetailsCustomFields
        visibilityDetailsMetadata
        visibilityDetailsReplay
        visibilityDetailsQM
        visibilityCleanUp
        visibilityExport
      }
      userId
      ownerName
      addConversations
      removeConversations
      exportFolders
      supervisors {
        name
        mail
        userId
      }
      attentionRequired
      allowedInPolicy
      conversations {
        day
        timein
        timeout
        topic
        id
        conversationId
        recordingType
        duration
        thumbnail
        notes
        isVideo
        hasVideo
        hasAudio
        hasChat
        hasFiles
        isHistoryVault
        hasScreenSharing
        hasUserScreen
        replayAllowed
        archiveAllowed
        archiveAccessType
        isRestoreApproved
        isApprover
        linkedUser {
          id
          userId
          tenantId
          name
        }
        callStartMs
        ownerDisplayName
        userId
        archiveStatus
        hasRestoreStarted
        customFields
        conversationSafe
        ttl
        incidents {
          caseId
          caseName
          status
          riskRating
          incidentThreadId
        }
      }
      isCaseManagement
      caseManagementDetails {
        caseStatus
        contentStatus
        legalHold
        observers
        reviewers
        reviewersName
        contentRiskRating
        caseThreadId
      }
    }
  }
`;

//query to retrieve list of folders flagged with
export const getFoldersAllowedForPolicies = gql`
  query getFoldersAllowedForPolicies($auth: AuthInput, $hasAddon: Boolean, $policyId: String) {
    getConversationSafeFolderLabelsPolicy(input: $auth, hasAddon: $hasAddon, policyId: $policyId) {
      id
      name
    }
  }
`;

// Variation to getAllFolders query to retrieve not all fields but only id and name. to populate dropdown input in ttl
// pivot.
export const getAllFoldersShrinked = gql`
  query getAllFoldersShrinked($auth: AuthInput, $filter: String) {
    getConversationSafeFolders(input: $auth, filter: $filter) {
      id
      name
      addConversations
      removeConversations
      userId
      isCaseManagement
      caseManagementDetails {
        reviewers
      }
    }
  }
`;

export const getConversationSafeFolder = gql`
  query getConversationSafeFolder($id: String, $auth: AuthInput) {
    getConversationSafeFolder(id: $id, input: $auth) {
      id
      name
      description
      addConversations
      removeConversations
      exportFolders
      supervisors {
        userId
      }
      visibilityDetails {
        visibilityDetailsActive
        visibilityDetailsNotes
        visibilityDetailsTranscript
        visibilityDetailsTTL
        visibilityDetailsAnalytics
        visibilityDetailsAnalyticsChange
        visibilityDetailsCustomFields
        visibilityDetailsMetadata
        visibilityDetailsReplay
        visibilityDetailsQM
        visibilityCleanUp
        visibilityExport
      }
      attentionRequired
      conversations {
        id
        conversationId
      }
      ownerName
      userId
      tenantId
      allowedInPolicy
      allowedToEditFlagAllowedInPolicy
      isCaseManagement
      caseManagementDetails {
        caseStatus
        contentStatus
        legalHold
        observers
        reviewers
        contentRiskRating
        caseThreadId
        isInActivePolicy
        allContentIsClosed
      }
    }
  }
`;

export const upsertConversationSafe = gql`
  mutation ent($auth: AuthInput, $conversationSafeFolder: ConversationSafeFolderInputType) {
    createConversationSafeFolder(input: $auth, conversationSafeFolder: $conversationSafeFolder) {
      id
      text
      status
    }
  }
`;

export const deleteConversationSafeFolder = gql`
  mutation deleteCSFolder($conversationSafeFolder: String) {
    deleteConversationSafeFolder(id: $conversationSafeFolder) {
      text
      status
    }
  }
`;

export const getIncidentThread = gql`
  query getIncidentThread($id: String, $input: AuthInput) {
    getIncidentThread(id: $id, input: $input) {
      id
      tenantId
      conversationId
      threads {
        userId
        userName
        statusType
        previousStatus
        currentStatus
        comment
        lastModifiedDate
      }
    }
  }
`;

export const getCaseStatusTypeEnum = gql`
  query ent {
    getCaseStatusTypeEnum {
      name
    }
  }
`;

export const getIncidentStatusTypeEnum = gql`
  query ent {
    getIncidentStatusTypeEnum {
      name
    }
  }
`;

export const changeIncidentStatus = gql`
  mutation ent($caseId: String, $conversationId: String, $newStatus: String, $comment: String) {
    changeIncidentStatus(caseId: $caseId, conversationId: $conversationId, newStatus: $newStatus, comment: $comment) {
      id
      text
      status
    }
  }
`;

export const changeIncidentRiskRating = gql`
  mutation ent($caseId: String, $conversationId: String, $newRiskRating: String) {
    changeIncidentRiskRating(caseId: $caseId, conversationId: $conversationId, newRiskRating: $newRiskRating) {
      id
      text
      status
    }
  }
`;

export const forwardTo = gql`
  mutation ent($caseId: String, $conversationId: String, $userSelected: String) {
    forwardTo(caseId: $caseId, conversationId: $conversationId, userSelected: $userSelected) {
      id
      text
      status
    }
  }
`;

export const moveTo = gql`
  mutation ent($caseIdFrom: String, $conversationId: String, $caseIdTo: String, $comment: String, $input: AuthInput!) {
    moveTo(caseIdFrom: $caseIdFrom, conversationId: $conversationId, caseIdTo: $caseIdTo, comment: $comment, input: $input) {
      id
      text
      status
    }
  }
`;

export const getCasesMyQueue = gql`
  query ent($auth: AuthInput) {
    getCasesMyQueue(input: $auth) {
      id
      name
      tenantId
      description
      visibilityDetails {
        visibilityDetailsActive
        visibilityDetailsNotes
        visibilityDetailsTranscript
        visibilityDetailsTTL
        visibilityDetailsAnalytics
        visibilityDetailsAnalyticsChange
        visibilityDetailsCustomFields
        visibilityDetailsMetadata
        visibilityDetailsReplay
        visibilityDetailsQM
        visibilityCleanUp
        visibilityExport
      }
      userId
      ownerName
      addConversations
      removeConversations
      exportFolders
      supervisors {
        name
        mail
        userId
      }
      attentionRequired
      allowedInPolicy
      conversations {
        day
        timein
        timeout
        topic
        id
        conversationId
        recordingType
        duration
        thumbnail
        notes
        isVideo
        hasVideo
        hasAudio
        hasChat
        hasFiles
        hasScreenSharing
        hasUserScreen
        replayAllowed
        archiveAllowed
        archiveAccessType
        isRestoreApproved
        isApprover
        linkedUser {
          id
          userId
          tenantId
          name
        }
        callStartMs
        ownerDisplayName
        userId
        archiveStatus
        hasRestoreStarted
        customFields
        conversationSafe
        ttl
        incidents {
          caseId
          caseName
          status
          riskRating
          incidentThreadId
        }
      }
      isCaseManagement
      caseManagementDetails {
        caseStatus
        contentStatus
        legalHold
        observers
        reviewers
        reviewersName
        contentRiskRating
        caseThreadId
      }
    }
  }
`;

export const getGroupListForLoggedUser = gql`
  query ent {
    getGroupListForLoggedUser
  }
`;

export const getGroups = gql`
  query ent {
    getGroups {
      name
      adGroupId
      users
    }
  }
`;
